import React, { useState } from 'react'
import InputTextWithSwitch from './InputTextWithSwitch';



const PrivacyManagement = () => {
    const [items, setItems] = useState([
        { id: 1, title: 'Search Visibility', selected: true, },
        { id: 2, title: 'Allow Contact', selected: true, },
        { id: 3, title: 'Show Development Program', selected: true, },
    ])

    const handleChange = (id, value) => {
        const updatedItems = items.map(item => {
            if(item.id === id){
                return { ...item, selected: value };
            }
            return item;
        })
        console.log(updatedItems, " = Privacy Management");
        setItems(updatedItems);
    }

  return (
    <div className='bg-pureWhite rounded-[16px] px-3 py-5 flex flex-col gap-y-4'>
      <p className="text-lg font-medium">Privacy Management</p>
      {items.map(item => <InputTextWithSwitch id={item.id} text={item.title} key={item.id} selected={item.selected} handleChange={handleChange} />)}
    </div>
  );
}

export default PrivacyManagement
